import { defineMessages } from 'react-intl';

export default defineMessages({
  filesTitlePage: {
    id: 'view.myaccount.step.homePage.filesTitlePage',
    defaultMessage: 'Files',
  },
});
